import React from 'react';
import classes from './style/VideoDescription.module.css';
const VideoDescription = ({ description, isLink }: { description: string; isLink: boolean }) => {
  return (
    <div
      className={isLink ? classes.videoDescriptionWrapperPlayer : classes.videoDescriptionWrapper}
    >
      <div className={classes.videoDescription} dangerouslySetInnerHTML={{ __html: description }} />
    </div>
  );
};

export default VideoDescription;
